import React, { useState, useEffect } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import axios from "axios";
import Frame from "../components/Frame";
import { getEventBySlug } from "../lib/events";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ComingSoon = () => {
  const { slug } = useParams();
  const event = getEventBySlug(slug);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  // If this slug is an active event, push the visitor straight to the live form.
  useEffect(() => {
    if (event && event.active) {
      window.location.replace(event.href);
    }
  }, [event]);

  if (!event) return <Navigate to="/events" replace />;
  if (event.active) {
    return (
      <div className="sc-page" data-testid="page-coming-redirect">
        <Frame as="section">
          <p style={{ textAlign: "center" }}>Redirecting you to the enquiry form…</p>
        </Frame>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setStatus({ state: "error", msg: "Please enter a valid email address." });
      return;
    }
    setStatus({ state: "loading", msg: "" });
    try {
      await axios.post(`${API}/notify-me`, {
        email,
        event_slug: event.slug,
        event_title: event.title,
      });
      setStatus({
        state: "success",
        msg: "Thank you — we'll be in touch the moment this experience is live.",
      });
      setEmail("");
    } catch (err) {
      setStatus({
        state: "error",
        msg: "Something went wrong. Please email sunstatecollective@gmail.com.",
      });
    }
  };

  const mailtoSubject = encodeURIComponent(
    `${event.title} enquiry — Sunstate Collective`
  );
  const mailtoBody = encodeURIComponent(
    `Hi Sunstate Collective,\n\nI'd love to enquire about ${event.title}.\n\nA bit about my event:\n- Date:\n- Location:\n- Guests:\n- Vision:\n\nThanks,\n`
  );
  const mailtoHref = `mailto:sunstatecollective@gmail.com?subject=${mailtoSubject}&body=${mailtoBody}`;

  return (
    <div
      className="sc-page sc-page-coming"
      data-testid={`page-coming-soon-${event.slug}`}
    >
      <Frame as="section" className="sc-coming" testId="coming-soon-section">
        <div
          className="sc-coming-image"
          style={{ backgroundImage: `url(${event.image})`, position: "relative" }}
          aria-hidden="true"
        >
          {event.isPlaceholder && (
            <span
              data-testid="coming-soon-stock-tag"
              style={{
                position: "absolute",
                left: 12,
                bottom: 12,
                padding: "4px 10px",
                fontSize: 10,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                color: "#fff",
                background: "rgba(34,34,34,0.62)",
                fontStyle: "italic",
                fontWeight: 500,
              }}
            >
              Stock image — for illustration only
            </span>
          )}
        </div>
        <div className="sc-coming-content">
          <span className="sc-section-eyebrow">COMING SOON</span>
          <h1 className="sc-page-title">{event.title}</h1>
          <p className="sc-coming-blurb">{event.blurb}</p>
          <p className="sc-coming-detail">
            We&rsquo;re crafting the perfect enquiry experience for this
            celebration type. Leave your email below and we&rsquo;ll be the
            first to let you know the moment it&rsquo;s live — or reach out
            directly and we&rsquo;ll happily begin planning by email in the
            meantime.
          </p>

          <form
            className="sc-notify-form"
            onSubmit={submit}
            data-testid="notify-form"
          >
            <label htmlFor="notify-email" className="sc-visually-hidden">
              Your email
            </label>
            <input
              id="notify-email"
              type="email"
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="notify-input-email"
              required
            />
            <button
              type="submit"
              className="sc-btn-primary"
              disabled={status.state === "loading"}
              data-testid="notify-submit"
            >
              {status.state === "loading" ? "SENDING…" : "NOTIFY ME"}
            </button>
          </form>

          {status.msg && (
            <p
              className={`sc-form-status sc-form-status-${status.state}`}
              data-testid="notify-status"
            >
              {status.msg}
            </p>
          )}

          <div className="sc-coming-divider">
            <span className="sc-coming-divider-line" />
            <span className="sc-coming-divider-text">OR</span>
            <span className="sc-coming-divider-line" />
          </div>

          <a
            href={mailtoHref}
            className="sc-btn-ghost sc-btn-full"
            data-testid="coming-email-cta"
          >
            ENQUIRE BY EMAIL
          </a>

          <div className="sc-coming-back">
            <Link to="/events" data-testid="coming-back-link">
              ← Back to all experiences
            </Link>
          </div>
        </div>
      </Frame>
    </div>
  );
};

export default ComingSoon;
